import React, { FC } from 'react';
import { MONTH_NAMES } from '../../data/constants';
import type { MonthDirection } from '../../utils/booking-analytics';

interface MonthNavProps {
  calendarMonth: number
  calendarYear: number
  onChangeMonth: (direction: MonthDirection) => void
  className: string
  buttonClassName: string
}

/** ‹ Month Year › header shared by the desktop calendar and the mobile date strip. */
const MonthNav: FC<MonthNavProps> = ({
  calendarMonth,
  calendarYear,
  onChangeMonth,
  className,
  buttonClassName,
}) => (
  <div className={className}>
    <button
      type="button"
      onClick={() => onChangeMonth('previous')}
      className={buttonClassName}
    >
      ‹
    </button>
    <span className="text-sm font-bold text-slate-800">
      {MONTH_NAMES[calendarMonth]}
      {' '}
      {calendarYear}
    </span>
    <button
      type="button"
      onClick={() => onChangeMonth('next')}
      className={buttonClassName}
    >
      ›
    </button>
  </div>
);

export default MonthNav;
